/**
* @file 战队-入队审批
* @author 余凯
*/

import React from 'react'
import { Table, Button, message } from 'antd';
import './index.less'

import { connect } from 'react-redux'

import Actions from '@/apis/team'

const columns = [
  {
    title: '申请队员ID',
    dataIndex: 'user_id',
  },
  {
    title: '申请队员昵称',
    dataIndex: 'nickname',
  },
  {
    title: '申请理由',
    dataIndex: 'self_info',
  },
  {
    title: '申请时间',
    dataIndex: 'apply_time',
  },
];

@connect(
  state => state.teamReducer,

)
class MemberManage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [], // Check here to configure the default column
      loading: false,
      data: [],
      totalCount: 0,
      current: 1,
      pageSize: 10
    }
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({
      selectedRowKeys,
    });
  };

  start = () => {
    this.setState({ loading: true });
    // ajax request after empty completing
    setTimeout(() => {
      this.setState({
        selectedRowKeys: [],
        loading: false,
      });
    }, 1000);
  };

  componentDidMount() {
    this.getData()
  }

  getData = async (pageCurrent = this.state.current) => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      page_index: pageCurrent,
      page_size: this.state.pageSize,
    }
    const res = await Actions.getApplyList(params)
    if (res.code == 200) {
      this.setState({
        data: res.data.list,
        totalCount: res.data.totalNumber,
        current: pageCurrent
      })
    }
  }

  handleChangePage = (page, pageSize) => {
    this.getData(page)
  }

  handleRemoveMember = async () => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      user_ids: this.state.selectedRowKeys
    }
    const res = await Actions.putRemoveMenber(params)
    if (res.code == 200) {
      message.success('操作成功')
      this.getData()
      this.setState({
        selectedRowKeys: [],
      })
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({
          filterName: values.name
        }, () => {
          this.getData(1)
        })
      }
    });
  };

  handleApply = async type => {
    const params = {
      id: this.props.userInfo.game_team_id,
      game_id: this.props.game,
      deal_type: type,
      user_ids: this.state.selectedRowKeys
    }
    const res = await Actions.postApplyUser(params)
    if (res.code == 200) {
      if (res.data.msg) message.error(res.data.msg)
      else {
        message.success('操作成功')
        this.getData()
        this.setState({
          selectedRowKeys: [],
        })
      }
    }
  }

  handleRow = (item) => {
    return {
      onClick: event => {
        const { selectedRowKeys } = this.state
        const i = selectedRowKeys.indexOf(item.user_id)
        if (i > -1) {
          selectedRowKeys.splice(i, 1)
          this.setState({
            selectedRowKeys
          })
        } else {
          selectedRowKeys.push(item.user_id)
          this.setState({
            selectedRowKeys
          })
        }
      }
    };
  }

  render() {
    const { data, pageSize, totalCount, current, selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const hasSelected = selectedRowKeys.length > 0;
    return (
      <div className="enqueue_approval" id="enqueue_approval">
        <h3>入队审批</h3>
        <div className="tip">请及时审批入队申请，系统将保留申请数据一定的时间，超时将会被系统自动清理。</div>
        <Table
          title={() => (
            <>
              <Button disabled={!hasSelected} type="primary" onClick={() => this.handleApply('accept')} >
                批准
              </Button>
              <Button disabled={!hasSelected} type="primary" onClick={() => this.handleApply('deny')} >
                拒绝
              </Button>
            </>
          )}
          size="small"
          rowKey={record => record.user_id}
          onRow={this.handleRow}
          rowSelection={rowSelection}
          columns={columns}
          pagination={{ pageSize, current, total: totalCount, onChange: this.handleChangePage }}
          dataSource={data} />
      </div>
    );
  }
}

export default MemberManage;
